import { useState, createContext, useEffect } from 'react';

import { ServLoginCheck } from '../servicos/login_check'
import { saveUserInfo } from '../util/informacoes_usuario';
import { ServGetTokenHttpOnly, servValidacaoToken } from '../servicos/servicosEmRotasPrivadas/login';

export const AuthContext = createContext({});

const AuthProvider = ({ children }) => {

    console.log('!!! Iniciando AuthProvider !!!');

    const [loading, setLoading] = useState(true);
    const [logado, setLogado] = useState(false);
    const [roles, setRoles] = useState([]);

    useEffect(() => {

        async function loadUserInfo() {

            let isLogado = false;
            let infoSMS = null;

            try {
                const { data } = await ServLoginCheck();
                // console.log('Checando se está logado:', data);
                isLogado = data.status
                infoSMS = data
            } catch (erro) {
                console.error(erro);
                setLoading(false)
                return
            }

            // console.log('Se estiver logado, vou partir para outras verificações');
            // o state 'logado' já inicia com false, entao só precisa setar se for true
            if (isLogado) {

                // console.log('Ta logado, agora vamos buscar mais informações sobre o usuário conectado e fazer algumas validações...');

                let validacaoToken = null;
                let infoGetTokenNTM = null;

                try {
                    validacaoToken = await servValidacaoToken()
                    // console.log('Validação do token HTTP-Only:', validacaoToken);
                } catch (error) {
                    console.error('Não foi possível validar o token HTTP-Only:', error);
                }

                if (validacaoToken) {
                    // console.log('Tudo OK com o token, setando as roles');
                    setRoles(validacaoToken.data.roles)
                } else { // pegando token novo

                    // console.log('Como a validação do token falhou, terei que tentar busca-lo');
                    try {
                        infoGetTokenNTM = await ServGetTokenHttpOnly(infoSMS.tokenAcesso);
                        // console.log('Consegui pegar um novo token:', infoGetTokenNTM);
                        setRoles(infoGetTokenNTM.data.roles)
                    } catch (error) {
                        console.error('Não foi possível obter o token HTTP-Only:', error);
                        setLoading(false)
                        // Desistindo do fluxo caso nao consiga pegar o tokenNTM
                        return
                    }

                    // console.log('Como eu tive que pegar um token novo, vou precisar atualizar as informações do usuário');
                    const userDataToLocalStorage = {
                        'nome': infoSMS.nome,
                        'cpf': infoSMS.cpf,
                        'unidade': infoSMS.unidade,
                        'roles': infoGetTokenNTM.data.roles
                    }
                    saveUserInfo(userDataToLocalStorage);
                }

            }

            setLogado(isLogado);
            setLoading(false);

        }

        loadUserInfo();

    }, []);

    return (

        <AuthContext.Provider value={{ signed: !!logado, loading, userRoles: roles }}>
            {/* o !!logado acima eh apenas pra forcar o valor como bool */}
            {children}
        </AuthContext.Provider>
    );
}

export default AuthProvider;
